import React, { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { Card, CardContent, Typography, Grid, Box, Button, Select, MenuItem } from '@mui/material';

const SurahDetails = () => {
  const { number } = useParams();
  const [surahInfo, setSurahInfo] = useState({});
  const [arabicTranslation, setArabicTranslation] = useState([]);
  const [englishTranslation, setEnglishTranslation] = useState([]);
  const [surahList, setSurahList] = useState([]);
  const [selectedSurah, setSelectedSurah] = useState(number);

  useEffect(() => {
    const fetchSurahDetails = async () => {
      try {
        // Fetch Surah information
        const surahInfoResponse = await fetch(`https://api.alquran.cloud/v1/surah/${selectedSurah}/ur.maududi`);
        const surahInfoData = await surahInfoResponse.json();
        setSurahInfo(surahInfoData.data);

        // Fetch Arabic and English translation data
        const translationResponse = await fetch(`https://api.alquran.cloud/v1/surah/${selectedSurah}/editions/quran-uthmani,ur.maududi`);
        const translationData = await translationResponse.json();
        setArabicTranslation(translationData.data[0]?.ayahs || []);
        setEnglishTranslation(translationData.data[1]?.ayahs || []);
      } catch (error) {
        console.error('Error fetching surah details:', error);
      }
    };

    fetchSurahDetails();
  }, [selectedSurah]);

  useEffect(() => {
    const fetchSurahs = async () => {
      try {
        const response = await fetch('https://api.alquran.cloud/v1/surah');
        const data = await response.json();
        setSurahList(data.data);
      } catch (error) {
        console.error('Error fetching surahs:', error);
      }
    };

    fetchSurahs();
  }, []);

  const handleNextSurah = () => {
    const nextSurah = parseInt(selectedSurah, 10) + 1;
    setSelectedSurah(nextSurah.toString());
  };

  const handlePrevSurah = () => {
    const prevSurah = parseInt(selectedSurah, 10) - 1;
    setSelectedSurah(prevSurah.toString());
  };

  const handleSurahChange = (event) => {
    setSelectedSurah(event.target.value);
  };

  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', marginTop: '20px' }}>
      <Typography variant="h4" sx={{ color: 'gold', marginBottom: '10px', fontFamily: 'Cinzel Decorative' }}>
        <strong style={{ color: 'darkslategrey' }}>Surah : </strong> {surahInfo.englishName}
      </Typography>
      <Box sx={{ display: 'flex', justifyContent: 'space-between', marginBottom: '10px', width: '100%' }}>
        <Button variant="contained" sx={{ width:'160px',height:'40px',  backgroundColor: 'gold', color: 'darkslategrey', marginLeft:'15px' }} onClick={handlePrevSurah}>
          Previous Surah
        </Button>
        <Select value={selectedSurah} onChange={handleSurahChange} sx={{ idth:'160px',height:'40px',backgroundColor: 'gold', color: 'darkslategrey' }}>
          {surahList.map((surah) => (
            <MenuItem key={surah.number} value={surah.number}>
              {surah.englishName}
            </MenuItem>
          ))}
        </Select>
        <Button variant="contained" sx={{ width:'120px',height:'40px',  backgroundColor: 'gold', color: 'darkslategrey', marginRight:'15px'}} onClick={handleNextSurah}>
          Next Surah
        </Button>
      </Box>
      <Grid container justifyContent="center" spacing={2}>
        {arabicTranslation.map((ayah, index) => (
          <Grid item xs={12} key={index}>
            <Card style={{ backgroundColor: 'darkslategray', margin: '5px', padding: '10px', textAlign: 'center' }}>
              <CardContent>
                <Typography variant="h4" sx={{ color: 'gold' }}>
                  {ayah.text}
                </Typography>
                <Typography variant="h5" sx={{ color: 'whitesmoke', fontWeight: 'lighter', fontStyle: 'oblique' }} gutterBottom>
                  "{englishTranslation[index]?.text}"
                </Typography>
                <Typography variant="h6" sx={{ fontFamily: 'Cinzel Decorative', color: 'white' }}>
                  <strong style={{ color: 'goldenrod' }}> Verse no. </strong> {ayah.numberInSurah}
                </Typography>
              </CardContent>
            </Card>
          </Grid>
        ))}
      </Grid>
    </Box>
  );
};

export default SurahDetails;
